<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        电表管理
        <small>电表管理</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"> <i class="fa fa-dashboard"></i> 电表管理 </a>
        </li>
        <li class="active">电表管理</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Main row -->
      <div class="col-sm-12">
        <div id="atptoolbar">
          <select class="chosen-subcomm-layer" v-model="subCom">
            <option value>选择分管运营商</option>
            <option v-for="(item, index) in sub_comm" :key="index" :value="item.name">
              {{ item.name }}
            </option>
          </select>
          <select class="chosen-model-layer" v-model="model_i">
            <option v-for="(item, index) in modelList" :key="index" :value="item.value">
              {{ item.name }}
            </option>
          </select>
          <button
            class="btn btn-info"
            type="button"
            id="sys_recordbutton"
            @click="getammeterid('ammeterRecord', 'sys_record_model')"
          >
            <!-- data-toggle="modal" data-target="#sys_record_model" -->
            <i class="fa fa-pencil"></i>&nbsp;电表查表记录
          </button>
          <!-- <button
                      class="btn btn-info"
                      type="button"
                      data-toggle="modal"
                      data-target="#sys_import_modal"
                      id="sys_imp"
                    >
                      <i class="fa fa-sign-in"></i>&nbsp;电表导入
                    </button>-->
          <button
            class="btn btn-warning"
            type="button"
            data-toggle="modal"
            @click="getammeterid('ammeterEdit', 'sys_ammeterEdit_modal')"
          >
            <!--  data-target="#sys_ammeterEdit_modal" id="sys_update" -->
            <i class="fa fa-pencil-square"></i>&nbsp;编辑
          </button>
          <button
            class="btn btn-warning"
            type="button"
            data-toggle="modal"
            @click="getammeterid('ammeterPic', 'sys_ammeterpic_modal')"
          >
            <i class="fa fa-pencil-square"></i>&nbsp;电表照片
          </button>
          <button class="btn btn-model" type="button" id="device" @click="ammetertype">
            <i class="glyphicon glyphicon-signal"></i>&nbsp;智能电表
          </button>
        </div>
        <table id="atptable"></table>
      </div>
      <!-- /.row (main row) -->
    </section>
    <!-- 电表查表记录 -->
    <v-ammeterrecord :msg-ammeterid="ammeterid" ref="ammeterRecord"></v-ammeterrecord>
    <!-- 电表导入 -->
    <!-- <v-ammeterImport></v-ammeterImport> -->
    <!-- 编辑 -->
    <v-ammeterEdit :msg-ammeterid="ammeterid" ref="ammeterEdit"></v-ammeterEdit>
    <v-ammeterpic :msg-ammeterid="ammeterid" ref="ammeterPic"></v-ammeterpic>
    <!-- 智能电表 -->
    <v-ammetersmart
      :msg-ammeterid="ammeterid"
      :msg-ammeterinfo="ammeterInfo"
      ref="ammetersmart"
    ></v-ammetersmart>
    <!-- /.content -->
  </div>
</template>

<script>
import ammeterrecord from "./ammeterrecord";
import ammeterImport from "./ammeterImport";
import ammeterEdit from "./ammeterEdit";
import ammetersmart from "./ammetersmart";
import ammeterpic from "./ammeterpic";

export default {
  data() {
    return {
      ammeterid: "", // 电表id
      ammeterInfo: {}, // 电表信息
      ammeternumber: "", // 电表编号
      org_id: "", // 公司id
      sub_comm: [], // 所有的分管运营商
      subCom: "", // 被选中的运营商
      modelList: [
        {
          name: "所有电表",
          value: "",
        },
        {
          name: "智能电表",
          value: "lot",
        },
        {
          name: "DDZY251-NB",
          value: "DDZY251-NB",
        },
      ], // 电表类型
      model_i: "", // 被选中的电表
    };
  },
  components: {
    "v-ammeterrecord": ammeterrecord,
    "v-ammeterImport": ammeterImport,
    "v-ammeterEdit": ammeterEdit,
    "v-ammetersmart": ammetersmart,
    "v-ammeterpic": ammeterpic,
  },
  mounted() {
    var self = this;
    var org_id = JSON.parse(localStorage.getItem("companyInfo")).id;
    self.org_id = org_id;
    self.getlist();

    $(".chosen-subcomm-layer")
      .chosen({
        disable_search_threshold: 10,
        disable_search: true,
        width: "160px",
      })
      .change(function () {
        self.subCom = $(".chosen-subcomm-layer").val();
        $("#atptable").bootstrapTable("refresh");
      });

    $(".chosen-model-layer")
      .chosen({
        disable_search_threshold: 10,
        disable_search: true,
        width: "160px",
      })
      .change(function () {
        self.model_i = $(".chosen-model-layer").val();
        $("#atptable").bootstrapTable("refresh");
      });

    // 获取所有的分管运营商
    self.global.axiosGet(self, "organizations/?search=运营商", function (res) {
      console.log("分管运营商", res);
      self.sub_comm = res;
      setTimeout(function () {
        $(".chosen-subcomm-layer").trigger("chosen:updated");
      }, 300);
    });
  },
  methods: {
    // 获取基站id 显示弹框
    getammeterid: function (funcname, eleid) {
      console.log(eleid);
      var self = this;
      var tablerow = $("#atptable").bootstrapTable("getSelections");
      if (tablerow.length == 0) {
        alert("您尚未选择数据");
      } else {
        var ammeterid = tablerow[0].id;
        self.ammeternumber = tablerow[0].ammeter_numbering;
        self.ammeterid = ammeterid;
        $("#" + eleid).modal("show");
        setTimeout(function () {
          self.$refs[funcname].getData(); // 调用子组件函数
        }, 1000);
      }
    },
    // 判断是否为智能表
    ammetertype: function () {
      var self = this;
      var tablerow = $("#atptable").bootstrapTable("getSelections");
      console.log(tablerow);
      if (tablerow.length == 0) {
        alert("您尚未选择数据");
      } else if (tablerow[0].model == null || tablerow[0].modal == "") {
        alert("该电表为非智能能表");
      } else {
        $("#sys_device_modal").modal("show");
        var ammeterid = tablerow[0].id;
        self.ammeternumber = tablerow[0].ammeter_numbering;
        self.ammeterid = ammeterid;
        self.ammeterInfo = tablerow[0];
        console.log('---',self.ammeterinfo);
        setTimeout(function () {
          self.$refs["ammetersmart"].intfunc(); // 调用子组件函数
        }, 1000);
      }
    },
    getlist: function () {
      var self = this;
      $("#atptable").bootstrapTable({
        url: self.global.apiHost + "ammeters/", //请求后台的URL（*）
        method: "get", //请求方式（*）
        ajaxOptions: {
          headers: {
            "content-type": "application/json", // 默认值
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        },
        toolbar: "#atptoolbar", //工具按钮用哪个容器
        height: $(window).height() * 0.85,
        striped: true, //是否显示行间隔色
        cache: false, //是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
        pagination: true, //是否显示分页（*）
        iconSize: "outline",
        sortable: false, //是否启用排序
        // sortName: "stam_atpid",
        // sortOrder: "DESC",
        queryParams: self.queryParams, //传递参数（*）
        sidePagination: "server", //分页方式：client客户端分页，server服务端分页（*）
        pageNumber: 1, //初始化加载第一页，默认第一页
        pageSize: 10, //每页的记录行数（*）
        pageList: [5, 10, 25, 50, 100], //可供选择的每页的行数（*）
        search: true, //是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
        showColumns: true, //是否显示所有的列
        showRefresh: true, //是否显示刷新按钮
        minimumCountColumns: 2, //最少允许的列数
        clickToSelect: true, //是否启用点击选中行
        uniqueId: "stam_atpid", //每一行的唯一标识，一般为主键列
        singleSelect: true,
        columns: [
          [
            { checkbox: true },
            {
              title: "序号",
              width: 40,
              formatter: function (value, row, index) {
                var option = $("#atptable").bootstrapTable("getOptions");
                return option.pageSize * (option.pageNumber - 1) + index + 1;
              },
            },
            {
              field: "ammeter_numbering",
              title: "电表编号",
              sortable: true,
              width: 150,
            },
            {
              field: "stam_category",
              title: "电表类型",
              sortable: true,
              width: 150,
            },
            {
              field: "model",
              title: "电表型号",
              sortable: true,
              width: 150,
              formatter: function (value, row, index) {
                // console.log(value);
                if (value == null || value == "") {
                  return "非智能表";
                } else {
                  return value;
                }
              },
            },
            {
              field: "stst_commname",
              title: "基站名称",
              sortable: true,
              width: 150,
            },

            {
              field: "stst_comm",
              title: "运营商",
              sortable: true,
              width: 150,
            },
            {
              field: "stst_subcomm",
              title: "分管运营商",
              sortable: true,
              width: 150,
            },

            // {
            //   field: "stam_ammeterpicture",
            //   title: "电表照片",
            //   sortable: true,
            //   width: 150,
            //   formatter: function(value, row, index) {
            //     var a =
            //       '<img src="' +self.global.ossHost+
            //       value +
            //       '" width="100px" /><br/>';
            //     if (null == value || "" == value) {
            //       return "";
            //     } else {
            //       return a;
            //     }
            //   }
            // },
            {
              field: "position",
              title: "电表位置",
              sortable: true,
              width: 150,
            },
            {
              field: "center",
              title: "经纬度",
              sortable: true,
              width: 150,
            },
            {
              field: "create_datetime",
              title: "添加时间",
              sortable: true,
              width: 150,
            },
            {
              field: "info",
              title: "信息备注",
              sortable: true,
              width: 200,
            },
          ],
        ],
        rowStyle: function (row, index) {
          //这里有5个取值代表5中颜色['active', 'success', 'info', 'warning', 'danger'];
          var strclass = "";
          // console.log(row.model);
          if (row.model == null || row.model == "") {
            return {};
          } else {
            strclass = "btn-model";
          }
          return { classes: strclass };
        },
        onSort: function (name, order) {},
        onLoadSuccess: function () {
          $("#atptable img").on("click", function () {
            $(".layerImg").remove();
            $("body").append(
              '<div class="layerImg" onclick="closeImg(this)"><img src="' +
                $(this).prop("src") +
                '"/></div>'
            );
          });

          // 添加样式
          $("table .btn-model").css({
            color: "#dedede",
            background: "rgb(76, 97, 108)",
          });
          $(".fixed-table-container tbody td").css({
            background: "none",
          });
        },
      });
    },
    queryParams: function (params) {
      var self = this;
      //配置参数
      params.per_page = params.limit; //每页行数
      params.page = params.offset / params.limit + 1; //当前页数
      params.org_id = self.org_id;
      params.sub_comm = self.subCom;
      params.model = self.model_i;
      // params.sortOrder = params.order; //排位命令（desc，asc）
      return params;
    },
  },
};
</script>
<style scoped>
.layerImg {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.layerImg img {
  display: block;
  height: 100%;
  margin: 0 auto;
}

/*智能电表按钮样式*/
.btn-model {
  color: #dedede;
  background-color: rgb(76, 97, 108);
}

.btn-model td {
  color: #dedede !important;
  background-color: rgb(76, 97, 108) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ammeter/ammeterlist.vue